"use client";
import Link from "next/link";
import { Button } from "@components/ui/button";

const LearningJourney = () => {
	return (
		<section className="w-full py-12 sm:py-16 lg:py-20">
			<div className="mx-auto flex w-full max-w-4xl flex-col items-center justify-center gap-10 px-4 text-center sm:px-6 lg:px-8">
				<div className="flex w-full flex-col items-center justify-center gap-3">
					<h2 className="text-foreground px-2 text-2xl leading-tight font-bold sm:text-3xl md:text-4xl lg:text-4xl">{"Ready to Begin Your Learning Journey?"}</h2>
					<p className="text-muted-foreground mx-auto max-w-2xl px-2 text-sm leading-relaxed sm:text-base md:text-lg">{"Get started with top-rated content and training support. Join over 50,000 satisfied learners today."}</p>
				</div>
				<div className="flex flex-col items-center justify-center gap-3 sm:flex-row">
					<Button asChild className="bg-secondary hover:bg-secondary/90 w-full rounded-full px-6 py-3 transition-colors duration-300 sm:w-auto sm:px-8 sm:py-4" size="lg">
						<Link href="/store">{"Browse All Courses"}</Link>
					</Button>
					<Button asChild className="border-secondary text-secondary hover:bg-secondary hover:text-secondary-foreground w-full rounded-full border-2 px-6 py-3 transition-colors duration-300 sm:w-auto sm:px-8 sm:py-4" size="lg" variant="outline">
						<Link href="/contact">Talk to Us for Enterprise Plans</Link>
					</Button>
				</div>
			</div>
		</section>
	);
};

export default LearningJourney;
